<nav class="breadcrumb" *ngIf="items.length > 1">
  <ng-container *ngFor="let item of items; let last = last">
    <span
      class="breadcrumb-item"
      [class.active]="last"
      [class.link]="!last && item.route"
      (click)="navigate(item)">
      {{ item.label | titlecase }}
    </span>
    <span class="separator" *ngIf="!last">›</span>
  </ng-container>
</nav>
